import React from 'react'
import { useAppSelector } from '../../store/hooks'

const Footer: React.FC = () => {
    const theme = useAppSelector((state) => state.theme.theme)

    return (
        <footer
            className={`sticky-footer bg-${
                theme === 'dark' ? 'dark' : 'white'
            }`}
        >
            <div className="container my-auto">
                <div className="copyright text-center my-auto">
                    <span>
                        Copyright © {process.env.REACT_APP_CLIENT_NAME}{' '}
                        {new Date().getFullYear()}
                    </span>
                </div>
            </div>
        </footer>
    )
}

export default Footer
